import io from 'socket.io-client'
import { computed } from 'vue'
import { mapActions } from 'vuex'

export default {
  data () {
    return {
      socket: null,
      notificationQueue: [],
      isProcessingQueue: false,
      processingTimeout: null,
      socketUrl: '',
    }
  },
  provide () {
    return {
      socket: computed(() => this.socket)
    }
  },
  watch: {
    '$store.state.auth.auth': {
      handler (newVal) {
        if (newVal) {
          this.initializeSocketConnection()
        } else {
          this.disconnectSocket()
        }
      },
      immediate: true,
    },
    '$notification.show': {
      handler (newVal) {
        if (!newVal && this.$notification?.position?.right) {
          this.$nextTick(() => {
            this.$notification.position = { top: true }
          })
        }
      },
      immediate: true,
    }
  },
  methods: {
    ...mapActions('notification', {
      addNotification: 'addOne',
    }),
    initializeSocketConnection() {
      this.socketUrl = this.$store.state.app.socketUrl
      this.connectSocket()
    },
    connectSocket () {
      if (!this.socket && this.socketUrl && this.$store.state.app.socketSid) {

        this.socket = io(this.socketUrl, {
          reconnectionDelayMax: 10000,
          query: {
            'socket_sid': this.$store.state.app.socketSid
          }
        })
        this.socket.on('notification', (data) => {
          try {
            this.addToNotificationQueue(JSON.parse(data))
          } catch (e) {
          }
        })
        this.socket.on('msg', (data) => {
          try {
            data = JSON.parse(data)
          } catch(e) {
            return console.error('Failed to parse WS payload ', data, 'error', e)
          }

          // TODO: support many different WS messages based on data.type?
          this.addNotification(data).then(hasBeenAdded => {
            if (hasBeenAdded) {
              this.addToNotificationQueue({
                notification: {
                  type: 'success',
                  message: 'You have a new notification',
                }
              })
            }
          })
        })
      }

    },
    disconnectSocket () {
      if (this.socket) {
        this.socket.disconnect()
        this.socket = null
      }
    },
    addToNotificationQueue (data) {
      this.notificationQueue.push(data)
      this.ensureProcessing()
    },
    ensureProcessing () {
      if (!this.isProcessingQueue) {
        this.processNextNotification()
      }
    },
    processNextNotification () {
      if (this.notificationQueue.length === 0) {
        this.isProcessingQueue = false
        return
      }

      this.isProcessingQueue = true
      const notificationData = this.notificationQueue.shift()
      this.showNotification(notificationData)

      this.processingTimeout = setTimeout(() => {
        this.processNextNotification()
      }, 3300)
    },
    showNotification ({ notification }) {
      this.$notification.show = true
      this.$notification.message = notification.message
      this.$notification.type = notification.type
      this.$notification.position = notification?.position ?? { right: true, top: true }
    }
  },
  beforeDestroy () {
    this.disconnectSocket()
    if (this.processingTimeout) {
      clearTimeout(this.processingTimeout)
    }
  },
}
